import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  Box,
  Flex,
  ModalBody,
} from "@chakra-ui/react"

import { IModalProps } from "./ModalTypes"

import Heading from "components/UI/atoms/Heading"
import IconButton from "components/UI/molecules/IconButton"

const Modal: React.FC<IModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  styles,
  closeOnOverlayClick,
  blockScrollOnMount,
  closeButtonIcon = "close",
  closeIconStyles
}) => {

  return (
    <ChakraModal closeOnOverlayClick={closeOnOverlayClick} isOpen={isOpen} onClose={onClose} isCentered blockScrollOnMount={blockScrollOnMount} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent
        width={styles?.width || "500px"}
        maxWidth={styles?.maxWidth || styles?.width || "500px"}
        height={styles?.height}
      >
        {title && (
          <Box
            padding={styles?.headerPadding}
            borderBottom="1px solid"
            borderColor="input_border_color_primary"
          >
            <Flex justifyContent="space-between" alignItems="center">
              <Heading title={title} variant="regular" size="m" />
              <IconButton iconStyles={closeIconStyles} iconName={closeButtonIcon} onClick={onClose} />
            </Flex>
          </Box>
        )}
        <ModalBody padding={styles?.bodyPadding}>{children}</ModalBody>
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal
